import { Button } from '@fluentui/react-components';
import { useNavigate } from 'react-router-dom';

// used by AuthContext.tsx
const RetryLogin = () => {
  const navigate = useNavigate();
  const handleRetry = () => {
    sessionStorage.clear();
    localStorage.clear();
    navigate('/');
  };

  return (
    <div className="p-4">
      <p className="text-lg mb-2">Click on the button below to re-login. This may fix your issue.</p>
      <Button appearance="primary" onClick={handleRetry}>
        Re-login
      </Button>
    </div>
  );
};

export default RetryLogin;
